import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-custom-tab-item',
  templateUrl: './tab-item.component.html',
  styleUrls: ['./tab-item.component.scss']
})
export class TabItemComponent implements OnInit {

  @Input() title: string;
  @Input() active = false;
  @Input() suffix: string | number | TemplateRef<any> | null = null;
  suffixTemplate: TemplateRef<any> | null;
  @Output() selected:EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
     if(typeof this.suffix == 'object')
     {
        this.suffixTemplate = this.suffix
     }
  }

  isStringSuffix(): boolean {
    return typeof this.suffix == "string" || typeof this.suffix == "number";
  }

}
